import { deepCopy } from "@p81-common/shell-core-js";

function mapDestinations(destinations, addresses) {
  return destinations.addressObjectIds
    .map((id) => addresses[id])
    .filter(Boolean);
}

function mapUpdatableObjects(destinations, updatableObjects) {
  return destinations.updatableObjectIds
    .map((cpId) => updatableObjects[cpId])
    .filter(Boolean);
}

export function splitTunnelingAddressesMap(
  network,
  relationships
) {
  const hybridSplitTunnelingAttributes =
    network.attributes.hybridSplitTunneling?.attributes;
  const { addresses, updatableObjects } = relationships;

  if (hybridSplitTunnelingAttributes) {
    const {
      includeDestinations,
      excludeDestinations,
      exclusionMode,
    } = hybridSplitTunnelingAttributes;

    network.attributes.splitTunneling.attributes = exclusionMode
      ? deepCopy(excludeDestinations)
      : deepCopy(includeDestinations);
    network.attributes.splitTunneling.attributes.exclusionMode = exclusionMode;

    if (includeDestinations?.addressObjectIds) {
      includeDestinations.addressObjectIds = mapDestinations(
        includeDestinations,
        addresses
      );
    }
    if (excludeDestinations?.addressObjectIds) {
      excludeDestinations.addressObjectIds = mapDestinations(
        excludeDestinations,
        addresses
      );
    }

    if (includeDestinations?.updatableObjectIds) {
      includeDestinations.updatableObjectIds = mapUpdatableObjects(
        includeDestinations,
        updatableObjects
      );
    }
    if (excludeDestinations?.updatableObjectIds) {
      excludeDestinations.updatableObjectIds = mapUpdatableObjects(
        excludeDestinations,
        updatableObjects
      );
    }
  }

  let splitTunnelingAttributes = network.attributes.splitTunneling?.attributes;
  if (splitTunnelingAttributes?.addressObjectIds) {
    splitTunnelingAttributes.addressObjectIds = mapDestinations(
      splitTunnelingAttributes,
      addresses
    );
  }
}
